import { Fragment } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import Button from "components/atoms/Button/Button";
import FlightForm from "./FlightForm";
import { IEditScheduleForm } from "../types";

export default function EditFlightForm() {
  const { control } = useFormContext<IEditScheduleForm>();
  const { fields, append, remove } = useFieldArray<IEditScheduleForm>({
    name: "flights",
    control,
  });

  const handleClickAppend = () => {
    append({
      airline_code: "",
      flight_number: "",

      departure_date: "",
      departure_time: "",
      from_airport_code: "",

      arrival_date: "",
      arrival_time: "",
      to_airport_code: "",

      is_manual: false,
    });
  };

  const handleRemove = (index: number) => {
    remove(index);
  };

  return (
    <>
      {fields.map((field, i) => (
        <Fragment key={field.id}>
          <FlightForm key={i} index={i} onRemove={() => handleRemove(i)} />
        </Fragment>
      ))}
      <Button onClick={handleClickAppend}>
        <FormattedMessage id="tracking.components.editScheduleDialog.addFlight" defaultMessage="Add flight" />
      </Button>
    </>
  );
}
